// Updates Game Time
export const updateGameTime = (update) =>{
        return {
        type:"UPDATE_GAME_TIME",
        payload:update
    };
};

export const addMediaToDict = (item) => {
    return {
        type:"ADD_MEDIA_TO_DICT",
        payload:item
    }
};

export const hereIAm = (update) =>{
    return {
        type:"WS_HERE_I_AM",
        payload:update
    }
};

export const removeNetworkGuest = (update) =>{
    return {
        type:"REMOVE_NETWORK_GUEST",
        payload:update
    }
};


//Requests a Web Socket upDate (such as when a guest joins the network)
export const requestSocketUpdate = (update) =>{
    return {
        type:"WEBSOCKET_UPDATE",
        payload:update
    }
};
/*
//Updates the props.currentActivity
export const updateCurrentActivity = (update) =>{
    return {
        type:"UPDATE_CURRENT_ACTIVITY",
        payload:update
    }
};
*/
//Updates the props.currentActivityData - The authoratative Object of the activity state
export const updateCurrentActivityData = (update) =>{
    return {
        type:"UPDATE_CURRENT_ACTIVITY_DATA",
        payload:update
    }
};

export const replaceCurrentActivityData = (update) => {
    return {
        type:"REPLACE_CURRENT_ACTIVITY_DATA",
        payload:update
    }
};

/********** Teams **********/



/******** Responses *******/
/*
//Register a Response From Team
export const registerActivityAnswer = (answer) =>{
    return {
        type:"ACTIVITY_REMOTE_RESPONSE",
        payload:answer
    }
};
*/
//Clear the last response from team
export const clearActivityResponse = () =>{
    return {
        type:"CLEAR_ACTIVITY_RESPONSE"
    }
};


//Add a Response to be considered
export const addPotentialResponse = (answer) =>{
    return {
        type:"ADD_RESPONSE_TO_BE_PROCESSED",
        payload: answer
    }
};

export const updatePotentialResponse = (allPotentials) =>{
    return {
        type:"REPLACE_POTENTIAL_RESPONSES",
        payload:allPotentials
    }
};




//Used to add an activity response to be reviewed
export const updateActivityResponse = (answer) => {
    return {
        type:"ACTIVITY_RESPONSE",
        payload:answer
    }
};

export const updateGameState = (update) =>{
    return {
        type:"UPDATE_GAME_STATE",
        payload:update
    };
};

export const updateGameStateTeams = (update) =>{
    return {
        type:"UPDATE_GAME_STATE_TEAMS",
        payload:update
    };
};

export const replaceGameStateTeams = (update) =>{
    return {
        type:"REPLACE_GAME_STATE_TEAMS",
        payload:update
    };
};

export const addActivityDataField = (update) =>{
    return {
        type:"ADD_ACTIVITY_DATA_FIELD",
        payload:update
    };
};
